import FaqList from './FaqList';

export default FaqList;
